import React, { useEffect, useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import EditIcon from "@mui/icons-material/Edit";

// import JS files
import Template from "../../../shares/Template";
import Header from "../../../shares/Header";
import AddContainer from "../../../shares/AddContainer";
import AddCity from "./AddCity";
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import TableIconModal from "../../../shares/TableIconModal";

// import others files

const City = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [openDisableModal, setOpenDisableModal] = useState(false);

  const [editItemData, setEditItemData] = useState(undefined);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 10,
    count: 0,
  });

  const handleModal = () => {
    setEditItemData(undefined);
    setOpenModal((before) => !before);
  };

  const [apiData, setApiData] = useState([]);

  const getUserData = useFetch({
    url: `User_Service/get_city_users`,
    method: "GET",
    trigger: true,
    pagination: paginationPageInfo,

    argFunc: (res) => {
      setApiData({ nodes: res.results });
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });

  const [postData, setPostData] = useState();
  const editUserData = useFetch({
    url: `User_Service/${editItemData?.username}/disable_user`,
    method: "POST",
    trigger: false,
    data: postData,
    argFunc: (res) => {
      getUserData.reFetch();
      setOpenDisableModal(false);
    },
  });

  const editComponent = (index, itemData) => {
    setOpenModal(true);
    setEditItemData(itemData);
  };

  const disableAction = (index, itemData) => {
    setOpenDisableModal(true);
    setEditItemData(itemData);
  };

  const handle_disable = () => {
    setPostData({
      is_active: !editItemData.is_active,
    });
    editUserData.reFetch();
  };

  const [tableLabels, setTableLabels] = useState([
    "استان",
    "شهر",
    "نام مسئول",
    "نام کاربری",
    "وضعیت",
    // "تغییر رمزعبور",
    "ویرایش",
    "فعال / غیرفعال",
  ]);
  const [tableItems, setTableItems] = useState([
    { key: "province_fa", type: "data" },
    { key: "city", type: "data" },
    { key: "name", type: "data" },
    { key: "username", type: "data" },
    { key: "fa_is_active", type: "data" },

    {
      key: "editAction",
      icon: <EditIcon />,
      hasIcon: true,
      type: "action",
      func: (index, itemData) => editComponent(index, itemData),
    },
    {
      key: "disableAction",
      type: "action",
      icon: <ToggleOffIcon />,
      hasIcon: true,
      func: (index, itemData) => disableAction(index, itemData),
    },
  ]);

  return (
    <>
      {openDisableModal && (
        <TableIconModal
          width="md:w-2/5"
          isRemove={true}
          removeText="آیا از فعال/غیرفعال کردن کاربری شهر اطمینان دارید؟"
          icon={<ToggleOffIcon />}
          openModal={openDisableModal}
          setOpenModal={setOpenDisableModal}
          handleRemoveOnClick={handle_disable}
        ></TableIconModal>
      )}

      {openModal && (
        <AddCity
          openModal={openModal}
          setOpenModal={setOpenModal}
          apiCall={getUserData}
          editItemData={editItemData}
          setEditItemData={setEditItemData}
        />
      )}
      <Template>
        <Header header="تنظیمات / دسترسی شهر" />
        <AddContainer
          onClick={handleModal}
          text="برای ایجاد دسترسی شهر جدید روی دکمه افزودن کلیک کنید."
        />
        <PanelTable
          labels={tableLabels}
          items={tableItems}
          data={apiData}
          paginationPageInfo={paginationPageInfo}
          setPaginationPageInfo={setPaginationPageInfo}
          setItem={setApiData}
          apiReFetch={getUserData}
        />
      </Template>
    </>
  );
};

export default City;
